var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEthereum = function SvgEthereum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_7209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3V9.6525L17.6228 12.165L12 3Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3735 3L6.75 12.165L12.3735 9.6525V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.764V21.2843L17.6265 13.5L12 16.764Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3735 21.2843V16.7633L6.75 13.5L12.3735 21.2843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5258L17.6228 12.261L12 9.75V15.5258Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.261L12.3735 15.5258V9.75L6.75 12.261Z",
    fill: "white",
    fillOpacity: 0.602
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_7209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgEthereum as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE1NF83MjA5KSI+CjxwYXRoIGQ9Ik0xMiAyNEMxOC42Mjc0IDI0IDI0IDE4LjYyNzQgMjQgMTJDMjQgNS4zNzI1OCAxOC42Mjc0IDAgMTIgMEM1LjM3MjU4IDAgMCA1LjM3MjU4IDAgMTJDMCAxOC42Mjc0IDUuMzcyNTggMjQgMTIgMjRaIiBmaWxsPSIjNjI3RUVBIi8+CjxwYXRoIGQ9Ik0xMiAzVjkuNjUyNUwxNy42MjI4IDEyLjE2NUwxMiAzWiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC42MDIiLz4KPHBhdGggZD0iTTEyLjM3MzUgM0w2Ljc1IDEyLjE2NUwxMi4zNzM1IDkuNjUyNVYzWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEyIDE2Ljc2NFYyMS4yODQzTDE3LjYyNjUgMTMuNUwxMiAxNi43NjRaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjYwMiIvPgo8cGF0aCBkPSJNMTIuMzczNSAyMS4yODQzVjE2Ljc2MzNMNi43NSAxMy41TDEyLjM3MzUgMjEuMjg0M1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMiAxNS41MjU4TDE3LjYyMjggMTIuMjYxTDEyIDkuNzVWMTUuNTI1OFoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNNi43NSAxMi4yNjFMMTIuMzczNSAxNS41MjU4VjkuNzVMNi43NSAxMi4yNjFaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjYwMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE1NF83MjA5Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";